import React from "react";
import { Link } from "react-router-dom";

const HomeTable = ({ tableHeadData, tableData, isLoader }) => {
  if (isLoader) return <p className="text-white">Loading...</p>;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border-separate border-spacing-y-3">
        <thead>
          <tr className="bg-tableBg rounded-lg overflow-hidden">
            {tableHeadData.map((head, index) => (
              <th
                key={head.id}
                className={`px-6 py-4 text-left text-white font-semibold text-base font-Inter
          ${index === 0 ? "rounded-tl-lg" : ""} 
          ${index === tableHeadData.length - 1 ? "rounded-tr-lg" : ""}`}
              >
                {index === tableHeadData.length - 1 ? "" : head.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {tableData.map((row, rowIndex) => (
            <tr key={row.id} className="bg-tableBg">
              <td
                className={`px-6 py-4 text-sm font-medium flex items-center gap-2 text-white 
          ${rowIndex === 0 ? "rounded-tl-lg" : ""} 
          ${rowIndex === tableData.length - 1 ? "rounded-bl-lg" : ""}`}
              >
                <img src={row.icon} alt={row.coin} className="w-6 h-6" />
                {row.coin}
              </td>

              <td className="px-6 py-4 text-sm text-white">{row.name}</td>

              <td className="px-6 py-4 text-sm text-white">{row.amount}</td>

              <td className="px-6 py-4 text-sm">
                <i
                  className={`${row.chart} ${row.chart.includes("up") ? "text-primary" : "text-red-500"
                    }`}
                ></i>
              </td>

              <td
                className={`px-6 py-4 text-sm
          ${rowIndex === 0 ? "rounded-tr-lg" : ""} 
          ${rowIndex === tableData.length - 1 ? "rounded-br-lg" : ""}`}
              >
                <Link
                  to={"/"}
                  className={`px-5 py-1.5 text-white font-semibold rounded-md text-sm ${row.action === "BUY" ? "bg-primary" : "bg-red-500"
                    }`}
                >
                  {row.action}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HomeTable;